import Navigation from "./Navigation";
import Footer from "./Footer";

const PageLayout = ({ children, onOpenWaitlist }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation onOpenWaitlist={onOpenWaitlist} />
      <main className="flex-1 pt-[94px]">{children}</main>
      <Footer />
    </div>
  );
};

export default PageLayout;
